import { motion } from "framer-motion";

import { navigationVariants } from "../variants";
import MenuItem from "./menuItem";
import { navLinks } from "layouts/default/data";

export const Navigation = () => (
  <motion.ul variants={navigationVariants}>
    {navLinks.map((link, key) => (
      <MenuItem {...link} key={key} />
    ))}
  </motion.ul>
);

export default Navigation;
